import React from 'react'

import BlockFunnelProduct from '@elo-kit/components/page-builder/blocks/funnel-product'

const FunnelProductPreview = (props) => <BlockFunnelProduct {...props} />

export default FunnelProductPreview
